module.exports = __webpack_public_path__ + "static/icons/icon-map--greece-ba69fd2ec9894f9f950df89d0623076b.svg";